// extracted by mini-css-extract-plugin
export default {"footerContainer":"styles_footerContainer__Tuw36","backButton":"styles_backButton__9mdPu","cardHeading":"styles_cardHeading__4gNcp"};